import { render, staticRenderFns } from "./LedgerSubParent.vue?vue&type=template&id=62b957d0&"
import script from "./LedgerSubParent.vue?vue&type=script&lang=js&"
export * from "./LedgerSubParent.vue?vue&type=script&lang=js&"
import style0 from "./LedgerSubParent.vue?vue&type=style&index=0&id=62b957d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports